import React from "react";
import { Container } from "@mui/material";
import GoogleAuthModal from "../authPopup/GoogleAuthModal";
import FondoDinamico from "../components/fondos/BoxBackground";

const Register = () => {
  return (
    <FondoDinamico>
      <Container
        maxWidth="sm"
        sx={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 4,
        }}
      >
        <GoogleAuthModal isLoginProp={false} />
      </Container>
    </FondoDinamico>
  );
};

export default Register;
